import { Card, Grid, IconButton } from '@mui/material';
import { Typography } from '@uhc-tempo/components';
import React from 'react';
import GenericModal from '../../../common/components/GenericModal.component';
import { averageVerbiage } from '../../../constants/AverageModalVerbiage';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { modalStyles } from '../../../styles/GenericModalComponentStyles';

const avgStyles = {
    belowAverage: {
        backgroundColor: '#EFF6EF',
        textColorClass: 'tds-bui-color-feedback-success-dark',
        textColorHex: '#007000',
    },
    meetsAverage: {
        backgroundColor: '#f4f4f4',
        textColorClass: 'tds-bui-color-gray-five',
        textColorHex: '#6E7072',
    },
    aboveAverage: {
        backgroundColor: '#FCF0F0',
        textColorClass: 'tds-bui-color-feedback-danger-dark',
        textColorHex: '#C40000',
    },
};

const AverageThresholdTag = ({ cost, costScale, currentDialogState, setDialogState }) => {
    let tagStyle = {};
    let textColor = {};
    let averageType = '';

    if (cost == undefined) {
        return null;
    }

    if (costScale?.toLowerCase() == 'below') {
        tagStyle = avgStyles.belowAverage;
    } else if (costScale?.toLowerCase() == 'meets') {
        tagStyle = avgStyles.meetsAverage;
    } else {
        tagStyle = avgStyles.aboveAverage;
    }

    delete tagStyle['color'];
    textColor = {
        color: tagStyle.textColorHex,
        marginBottom: '0px',
    };
    averageType = costScale + ' Average Cost';

    return (
        <div overflow="hidden">
            <Grid container>
                <Grid item>
                    <Card
                        display="inline-block"
                        style={{ ...tagStyle, display: 'inline-block' }}
                        sx={{
                            paddingY: '4px',
                            paddingX: '8px',
                            boxShadow: 0,
                        }}
                        data-testid="tag-card"
                    >
                        {' '}
                        <Typography.Paragraph style={textColor}>{averageType}</Typography.Paragraph>
                    </Card>
                </Grid>

                <Grid item>
                    <IconButton
                        aria-label="info"
                        sx={{
                            marginTop: '-6px',
                            '&.MuiButtonBase-root:focus': {
                                outline: 'none !important',
                            },
                        }}
                        onClick={() => {
                            setDialogState(!currentDialogState);
                        }}
                    >
                        <InfoOutlinedIcon color="primary" />
                    </IconButton>
                </Grid>
            </Grid>
            <GenericModal
                showModalDialog={currentDialogState}
                modalStyles={modalStyles}
                modalLabel="Average"
                setShowModalDialog={setDialogState}
                modalTitle={averageType}
                modalBody={averageVerbiage()}
            >
                Random Text
            </GenericModal>
        </div>
    );
};
export default AverageThresholdTag;
